import React, { useState, useEffect } from 'react';
import { Descriptions, Table, Tooltip, Form, Tabs, Empty } from 'antd';

import {
    PlusCircleOutlined,
    MinusCircleOutlined,
    ExclamationCircleOutlined,
    CloseCircleOutlined} from '@ant-design/icons';

    import dayjs from 'dayjs'
    import 'dayjs/locale/ru'
import CRUDE_VoprosiPovestkiDnyaZasedaniyaRegPravleniya from '../../../objects/VoprosiPovestkiDnyaZasedaniyaRegPravleniya/crude';
import CRUDE_PrisutstvuyushchieNaZasedaniiRegPravleniya from '../../../objects/PrisutstvuyushchieNaZasedaniiRegPravleniya/crude'

const { TabPane } = Tabs;
dayjs.locale('ru');

export default function ZasedaniyaPravleniyaFederatsii(props) {
    const { auth, object } = props;

    const [vpd, setVpd] = useState([]);
    const [pris, setPris] = useState([]);

    useEffect(() => {
        CRUDE_VoprosiPovestkiDnyaZasedaniyaRegPravleniya.read(auth, (data) => {
            if (data.length > 0) {
                setVpd(data.sort((a, b) => {
                    if (a.ID < b.ID) {
                        return -1;
                    }
                    if (a.ID > b.ID) {
                        return 1;
                    }
                    return 0;
                }));
            }
        }, 'model', 'w-ZasedanieRegionalnogoPravleniya.ID=' + object.ID);
        CRUDE_PrisutstvuyushchieNaZasedaniiRegPravleniya.read(auth, (data) => {
            if (data.length > 0) {
                setPris(data.sort((a, b) => {
                    var ai = a.chlenFederatsii.user.lastname + " " + a.chlenFederatsii.user.firstname + " " + a.chlenFederatsii.user.patronymic;
                    var bi = b.chlenFederatsii.user.lastname + " " + b.chlenFederatsii.user.firstname + " " + b.chlenFederatsii.user.patronymic;
                    if (ai < bi) {
                        return -1;
                    }
                    if (ai > bi) {
                        return 1;
                    }
                    // a должно быть равным b
                    return 0;
                }));
            }
        }, 'model', 'w-ZasedanieRegionalnogoPravleniya.ID=' + object.ID);
    }, []);

    const prisColumns = [
        {
            render: (text, record) => {
                return (record.chlenFederatsii.user.lastname + " " + record.chlenFederatsii.user.firstname + " " + record.chlenFederatsii.user.patronymic);
            }
        },
        {
            render: (text, record) => {
                if (record.prezidentFederatsiiID) return ("Президент федерации");
                if (record.revizorFederatsiiID) return ("Ревизор федерации");
                if (record.chlenPravleniyaFederatsiiID) return ("Член правления федерации");
            }
        },
    ];
    const vpdColumns = [
        {
            title: '№',
            render: (text, record) => {
                return (record.nomerVoprosa);
            }
        },
        {
            title: 'Вопрос',
            render: (text, record) => {
                return (record.voprosPovestkiDnya);
            }
        },
        {
            title: 'Решение',
            render: (text, record) => {
                return (record.resheniePoVoprosuPovestkiDnya);
            }
        },
        {
            title: <Tooltip title="За"><PlusCircleOutlined style={{ color: "green" }} /></Tooltip>,
            render: (text, record) => {
                return (record.za);
            }
        },
        {
            title: <Tooltip title="Против"><MinusCircleOutlined style={{ color: "red" }} /></Tooltip>,
            render: (text, record) => {
                return (record.protiv);
            }
        },
        {
            title: <Tooltip title="Воздержался"><ExclamationCircleOutlined style={{ color: "orange" }} /></Tooltip>,
            render: (text, record) => {
                return (record.vozderzhalsya);
            }
        },
        {
            title: <Tooltip title="Не проголосовал"><CloseCircleOutlined style={{ color: "grey" }} /></Tooltip>,
            render: (text, record) => {
                return (record.neProgolosoval);
            }
        },
        {
            title: 'Принято',
            render: (text, record) => {
                return ((record.prinyatoReshenie)?record.prinyatoReshenie.opisanie:"");
            }
        },
    ];
    return (
        <Form
            form={props.form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
        >
            <Descriptions bordered column={{ xs: 1, sm: 1, md: 1 }} size={"small"} >
                <Descriptions.Item label="Номер протокола заседания">{object.nomerProtokolaZasedaniya}</Descriptions.Item>
                <Descriptions.Item label="Дата заседания">{dayjs(object.dataZasedaniya).tz("Europe/Moscow").format('DD.MM.YYYY HH:mm')}</Descriptions.Item>
                <Descriptions.Item label="Место проведения заседания">{object.mestoProvedeniyaZasedaniya.name}</Descriptions.Item>
                <Descriptions.Item label="Необходимый кворум">{object.neobkhodimiiKvorum}%</Descriptions.Item>
                <Descriptions.Item label="Количество вопросов повестки дня">{vpd.length}</Descriptions.Item>
            </Descriptions>
            <Tabs defaultActiveKey="1">
                <TabPane tab="Вопросы повестки дня" key="1">
                <Table columns={vpdColumns} dataSource={vpd} style={{ paddingBottom: "15px" }} locale={{ emptyText: <Empty description={"Нет вопросов повестки дня"}></Empty> }} size="small" rowKey={(r) => r.ID} />
                </TabPane>
                <TabPane tab="Присутствующие на заседании" key="2">
                <Table columns={prisColumns} dataSource={pris} showHeader={false} style={{ paddingBottom: "15px" }} locale={{ emptyText: <Empty description={"Нет присутствующих на заседании"}></Empty> }} size="small" rowKey={(r) => r.ID} />

                </TabPane>
            </Tabs>
            
        </Form>
    );
}
